import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import type { Ref } from 'vue'
// types
import type { StrapiHeader } from '@ts-strapi/interfaces'
// hooks
import { useScrollLock } from '@vueuse/core'

export interface HeaderMobileDrawerProps {
  data: StrapiHeader
  isOpen: boolean
}

interface HeaderMobileDrawerOptions {
  props: HeaderMobileDrawerProps
  onClose: () => void
}

interface HeaderMobileDrawerReturn {
  refExpandedIndex: Ref<number | null>
  expand: (index: number) => void
  collapse: (index: number) => void
  handleClose: () => void
}

export const useHeaderMobileDrawer = ({ props, onClose }: HeaderMobileDrawerOptions): HeaderMobileDrawerReturn => {
  const refExpandedIndex = ref<number | null>(null)
  const refIsScrollLocked = useScrollLock(import.meta.client ? document.body : null)

  const expand = (index: number): void => {
    refExpandedIndex.value = index
  }

  const collapse = (index: number): void => {
    if (refExpandedIndex.value === index) refExpandedIndex.value = null
  }

  const handleClose = (): void => {
    onClose()
  }

  const handleKey = (event: KeyboardEvent): void => {
    if (event.key === 'Escape' && props.isOpen) onClose()
  }

  watch(() => props.isOpen, (open) => {
    refIsScrollLocked.value = open
    if (!open) refExpandedIndex.value = null
  })

  onMounted(() => document.addEventListener('keydown', handleKey))
  onBeforeUnmount(() => document.removeEventListener('keydown', handleKey))

  return {
    refExpandedIndex,
    expand,
    collapse,
    handleClose,
  }
}